import React from 'react';

// Bootstrap
import Container from 'react-bootstrap/Container';

// Context
import { useImage, useData } from '../../contexts/Data';

// Carousel
import Carousel from 'react-multi-carousel';

import 'react-multi-carousel/lib/styles.css';
import './styles.css';

const Quotes = () => {
    // Controls the amout of items
    const responsive = {
        standard: {
            breakpoint: { max: 4000, min: 0 },
            items: 1,
        },
    };

    const { quotesImage } = useImage();
    const { setTheme } = useData();

    const quoteList = [
        {
            key: 0,
            text:
                '"Não construímos serviços para ganhar dinheiro, ganhamos dinheiro para construir melhores serviços".',
            author: 'Mark Zuckerberg',
        },
        {
            key: 1,
            text:
                '"Todos nós precisamos de pessoas que nos dêem feedback. É assim que melhoramos".',
            author: [
                'Bill ',
                <span key="span-egg" onClick={() => setTheme('machoman')}>
                    Gates
                </span>,
            ],
        },
        {
            key: 2,
            text:
                '"A única maneira de fazer um grande trabalho é amar o que você faz".',
            author: 'Steve Jobs',
        },
    ];

    return (
        <section className="quotes-section" style={quotesImage}>
            <div>
                <Container>
                    <Carousel
                        responsive={responsive}
                        showDots={true}
                        infinite={true}
                        autoPlay={true}
                        autoPlaySpeed={10000}
                        customTransition="all 1s"
                        arrows={false}
                    >
                        {quoteList.map(quote => (
                            <blockquote
                                key={`quote-${quote.key}`}
                                className="single-quote text-center"
                            >
                                <p>{quote.text}</p>
                                <footer>
                                    <cite title="Source">{quote.author}</cite>
                                </footer>
                            </blockquote>
                        ))}
                    </Carousel>
                </Container>
            </div>
        </section>
    );
};

export default Quotes;
